import { render, staticRenderFns } from "./GridProductsColumn.vue?vue&type=template&id=00d04794&"
import script from "./GridProductsColumn.ts?vue&type=script&lang=js&"
export * from "./GridProductsColumn.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports